/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ListingTile } from '../models/ListingTile';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ListingTileService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Retrieves a ListingTile resource.
     * Retrieves a ListingTile resource.
     * @param limit
     * @param position
     * @param currentPage
     * @param adults
     * @param amenity
     * @param amenityGroup
     * @param bookableOnline
     * @param bookingOptions
     * @param category
     * @param children
     * @param childrenAge
     * @param dateFrom
     * @param dateTo
     * @param onlyActive
     * @param provision
     * @param rating
     * @param region
     * @param voivodeship
     * @param latitude
     * @param longitude
     * @param country Country ID from NOP
     * @param radius Radius to search within coordinates in meters
     * @param order Order by distance from provided coordinates
     * @param city
     * @param nocCountry Country ID from Noc
     * @param flexibleDays
     * @param noPrice
     * @param cms
     * @param cmsFieldPath
     * @param cmsDocumentId
     * @param poi POI ID to search accommodations around
     * @param priceFrom
     * @param priceTo
     * @returns ListingTile ListingTile resource
     * @throws ApiError
     */
    public accommodationListingTile(
        limit?: number,
        position?: number,
        currentPage?: number,
        adults?: number,
        amenity?: Array<string>,
        amenityGroup?: Array<string>,
        bookableOnline?: 0 | 1,
        bookingOptions?: Array<string>,
        category?: Array<string>,
        children?: number,
        childrenAge?: Array<number>,
        dateFrom?: string,
        dateTo?: string,
        onlyActive?: 0 | 1,
        provision?: Array<string>,
        rating?: number,
        region?: number,
        voivodeship?: number,
        latitude?: number,
        longitude?: number,
        country?: number,
        radius?: number,
        order?: Array<string>,
        city?: number,
        nocCountry?: number,
        flexibleDays?: number,
        noPrice?: 0 | 1,
        cms?: string,
        cmsFieldPath?: string,
        cmsDocumentId?: string,
        poi?: string,
        priceFrom?: number,
        priceTo?: number,
    ): CancelablePromise<ListingTile> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/accommodations/listing/tile',
            query: {
                limit: limit,
                position: position,
                currentPage: currentPage,
                adults: adults,
                amenity: amenity,
                'amenity-group': amenityGroup,
                'bookable-online': bookableOnline,
                'booking-options': bookingOptions,
                category: category,
                children: children,
                'children-age': childrenAge,
                'date-from': dateFrom,
                'date-to': dateTo,
                'only-active': onlyActive,
                provision: provision,
                rating: rating,
                region: region,
                voivodeship: voivodeship,
                latitude: latitude,
                longitude: longitude,
                country: country,
                radius: radius,
                order: order,
                city: city,
                'noc-country': nocCountry,
                'flexible-days': flexibleDays,
                'no-price': noPrice,
                cms: cms,
                'cms-field-path': cmsFieldPath,
                'cms-document-id': cmsDocumentId,
                poi: poi,
                'price-from': priceFrom,
                'price-to': priceTo,
            },
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
}
